export const REMOVE_SIGNED_DOCUMENT_PENDING = 'REMOVE_SIGNED_DOCUMENT_PENDING'
export const SET_EXPORT_SIGNED_DOCUMENT_TO_IMANAGE_ERROR = 'SET_EXPORT_SIGNED_DOCUMENT_TO_IMANAGE_ERROR'
export const SET_EXPORT_SIGNED_DOCUMENT_TO_IMANAGE_PENDING = 'SET_EXPORT_SIGNED_DOCUMENT_TO_IMANAGE_PENDING'
export const SET_FILTERS_END_DATE = 'SET_FILTERS_END_DATE'
export const SET_FILTERS_SIGNATORIES = 'SET_FILTERS_SIGNATORIES'
export const SET_FILTERS_START_DATE = 'SET_FILTERS_START_DATE'
export const SET_LOADING = 'SET_LOADING'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_SIGNED_DOCUMENTS = 'SET_SIGNED_DOCUMENTS'
export const SET_SIGNED_DOCUMENT_ERROR = 'SET_SIGNED_DOCUMENT_ERROR'
export const SET_SIGNED_DOCUMENT_PENDING = 'SET_SIGNED_DOCUMENT_PENDING'